import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { JobRequestSummaryDto } from '@models/job-request-summary.interface';
import { MaterialDetailDialogComponent } from '../../inventory/inventory-dialog/material-detail-dialog/material-detail-dialog.component';
import {
  CommentsDialogComponent,
  CommentsDialogData,
} from '@shared/components/comments-dialog/comments-dialog.component';

@Component({
  selector: 'app-mud-check-tile',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './mud-check-tile.component.html',
  styleUrls: ['./mud-check-tile.component.scss']
})
export class MudCheckTileComponent {
  @Input() jobRequest: JobRequestSummaryDto | null = null;
  @Input() isEditable = false;

  @Output() goToDetails = new EventEmitter<JobRequestSummaryDto>();
  @Output() openReport = new EventEmitter<JobRequestSummaryDto>();
  @Output() openWorksheet = new EventEmitter<JobRequestSummaryDto>();
  @Output() delete = new EventEmitter<JobRequestSummaryDto>();
  @Output() removeMaterial = new EventEmitter<JobRequestSummaryDto>();
  @Output() unlock = new EventEmitter<JobRequestSummaryDto>();

  private readonly dialog = inject(MatDialog);

  protected onView() { if (this.jobRequest) this.goToDetails.emit(this.jobRequest); }
  protected onOpenReport() { if (this.jobRequest) this.openReport.emit(this.jobRequest); }
  protected onOpenWorksheet() { if (this.jobRequest) this.openWorksheet.emit(this.jobRequest); }
  protected onOpenComments(): void {
    const design = this.jobRequest?.firstSingleMaterialDesign;
    if (!design) return;

    this.dialog.open<CommentsDialogComponent, CommentsDialogData>(
      CommentsDialogComponent,
      {
        data: {
          designId: design.id,
          designName: design.name,
        },
        width: '700px',
        disableClose: true,
      }
    );
  }
  protected onDelete() { if (this.jobRequest) this.delete.emit(this.jobRequest); }
  protected onRemoveMaterial(): void {
    if (this.jobRequest) this.removeMaterial.emit(this.jobRequest);
  }
  protected onUnlock() { if (this.jobRequest) this.unlock.emit(this.jobRequest); }

  protected onOpenMaterial(materialId: number, jobRequestId: number): void {
    this.dialog.open(MaterialDetailDialogComponent, {
      width: '600px',
      minWidth: '600px',
      maxHeight: '90vh',
      data: { materialId, jobRequestId },
    });
  }

  protected statusClass(status?: string | null): string {
    if (!status) return 'status-unknown';
    const s = status.toLowerCase();
    if (s.includes('pass') || s.includes('ok') || s.includes('complete') || s.includes('completed')) return 'status-pass';
    if (s.includes('fail') || s.includes('failed') || s.includes('error')) return 'status-fail';
    if (s.includes('pending') || s.includes('inprogress') || s.includes('in progress') || s.includes('inprogress')) return 'status-pending';
    return 'status-unknown';
  }

  protected statusLabel(status?: string | null): string {
    return status ?? 'Unknown';
  }
}
